module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region-tutorial-ios"
  }, [_c('h2', {
    staticClass: "region-tutorial-ios-title"
  }, [_vm._v("更改 Apple ID 国家或地区教程")]), _vm._v(" "), _c('div', {
    staticClass: "region-tutorial-ios-content"
  }, [_c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_login.png"),
      "alt": "rti-img-login"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 1 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("登录 Apple ID")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('p', [_vm._v("\n            进入 Apple 官网\n            "), _c('a', {
    staticClass: "link-color",
    attrs: {
      "href": "https://appleid.apple.com",
      "target": "_blank"
    }
  }, [_vm._v("https://appleid.apple.com")]), _vm._v(" 登录自己的 Apple ID\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_select.png"),
      "alt": "rti-img-select"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 2 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("选择个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('p', [_vm._v("登录成功后选择【个人信息】继续")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_enter.png"),
      "alt": "rti-img-enter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 3 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("进入国家或地区更改页面")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('p', [_vm._v("点击【国家或地区】，之后点击【更改国家或地区】进入付款方式信息填写页面")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_modify.png"),
      "alt": "rti-img-modify"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 4 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更改国家或地区到 Hong Kong（香港）")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('ul', [_c('li', [_vm._v("【国家或地区】选择【香港】；")]), _vm._v(" "), _c('li', [_vm._v("【付款方式】选择【无】；")]), _vm._v(" "), _c('li', [_vm._v("地址和姓名可随意填写；")]), _vm._v(" "), _c('li', [_vm._v("地区码为 852，电话号码是 8 位，必须为 9 或者 6 开头")]), _vm._v(" "), _c('li', [_vm._v("填写完信息之后点击【更新】，保存信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_check.png"),
      "alt": "rti-img-check"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 5 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("查看更改后的信息")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('p', [_vm._v("保存信息后即可返回查看自己账号的地区是否已修改为香港")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item"
  }, [_c('img', {
    staticClass: "rtic-item-img",
    attrs: {
      "src": require("../../../static/img/regionTutorialIos/img_download.png"),
      "alt": "rti-img-download"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content"
  }, [_c('h3', {
    staticClass: "rtic-item-content-title"
  }, [_vm._v("第 6 步")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("下载 Plex加速器")]), _vm._v(" "), _c('div', {
    staticClass: "rtic-item-content-text"
  }, [_c('p', [_vm._v("信息修改完成之后，您便可以打开 App Store，搜索 PlexVPN 并下载安装")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7df2df3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/regionTutorialIOS/regionTutorialIOS.vue
// module id = 1360
// module chunks = 1